import { DraftLeaderboardCoursesInner } from '@spikemark/rest-api';
import { OptionalTooltip } from '../../../../components/optional-tooltip';
import classNames from 'classnames';
import { Star } from 'lucide-react';
import { rankToDisplayValue } from '../../../../utils/format';
import { cn } from '../../../../utils/cn';
export const CourseLabelDisplay = ({
  courseLabels,
  courseInfoMap,
  suppressTooltip,
  roundId
}: {
  courseLabels?: string[];
  roundId: number;
  suppressTooltip?: boolean;
  courseInfoMap?: Record<string, DraftLeaderboardCoursesInner>;
}) => {
  const courseLabel = courseLabels?.[roundId - 1] ?? courseLabels?.[0] ?? undefined;
  return courseLabel && courseInfoMap ? <OptionalTooltip tooltipContent={suppressTooltip ? undefined : <div>
            Course {courseLabel} - {courseInfoMap?.[[roundId, courseLabel].join('-')]?.courseName}
          </div>} className="flex-none inline-block ml-auto pl-1.5" align="center" side="left" data-sentry-element="OptionalTooltip" data-sentry-component="CourseLabelDisplay" data-sentry-source-file="shared.tsx">
      <div className={classNames('cursor-pointer bg-white border border-secondary rounded-full w-5 h-5 p-1 flex items-center justify-center text-xs hover:bg-gray-100', {
      'pointer-events-none': suppressTooltip
    })}>
        {courseLabel}
      </div>
    </OptionalTooltip> : <></>;
};
export const OverallRankDisplay = ({
  overallRank,
  displayCutoff,
  variant = 'default'
}: {
  overallRank?: number;
  displayCutoff?: number;
  variant?: 'default' | 'simple';
}) => {
  return overallRank && overallRank < 9000 && (
  // Ensure displayCutoff=0 is being respected
  typeof displayCutoff === 'number' ? overallRank <= displayCutoff : true) ? <span className={cn('block', {
    'bg-gray-300 px-2 rounded-md w-fit flex items-center text-base': variant === 'default',
    'text-2xs lg:text-sm': variant === 'simple'
  })} data-sentry-component="OverallRankDisplay" data-sentry-source-file="shared.tsx">
      {variant === 'default' && <Star size={16} className="mr-1 fill-gray-400 text-gray-400" />}
      <span className="text-black">{rankToDisplayValue(overallRank)}</span>
    </span> : null;
};